/* jshint eqnull:true */
define(["jquery"], function($) {

	var ContextRoot = '/webapp/wcs/stores/servlet/';
	var SEOContextRoot = '/shop/';

	function getCookie(c_name) {
		//copied from http://www.w3schools.com/js/js_cookies.asp
		var i,x,y,ARRcookies=document.cookie.split(";");
		for (i=0;i<ARRcookies.length;i++) {
			x=ARRcookies[i].substr(0,ARRcookies[i].indexOf("="));
			y=ARRcookies[i].substr(ARRcookies[i].indexOf("=")+1);
			x=x.replace(/^\s+|\s+$/g,"");
			if (x==c_name) {
				return unescape(y);
			}
		}
	}
	function setCookie(c_name,value,exdays) {
		//copied from http://www.w3schools.com/js/js_cookies.asp
		var exdate=new Date(), c_value;
		exdate.setDate(exdate.getDate() + exdays);
		c_value=escape(value) + ((exdays==null) ? "" : "; expires="+exdate.toUTCString()) + "; path=/";
		document.cookie=c_name + "=" + c_value;
	}
	function getWCCookieName(c_name){
		return c_name + getStoreId();
	}
	function setWCCookie(c_name,value,exdays){
		setCookie(getWCCookieName(c_name),value,exdays);
	}
	function removeCookie(cookie_name) {
		setCookie(cookie_name, "", -1);
	}
	function getWCCookie(cookiename, defaultvalue) {
		var wc_cookie = getCookie( getWCCookieName(cookiename) );
		if ( wc_cookie == null ) {
			wc_cookie = getCookie( cookiename );
		}
		if ( wc_cookie == null ) {
			wc_cookie = defaultvalue;
		}
		return wc_cookie;
	}
	function removeWCCookie(cookie_name) {
		removeCookie( getWCCookieName(cookie_name) );
	}
	
	//move this function to context.js
	function removeCookies(identifier){
	
		var cookies = [];
		
		cookies = document.cookie.split(';');

		for (var index = 0; index < cookies.length; index++){

			if (cookies[index].search(identifier) != -1)
				removeCookie((cookies[index].substr(0, cookies[index].indexOf('='))));
		}
	}
	
	//move this function to context.js
	function getCookies(identifier){
	
		var cookies = [];
		
		cookies = document.cookie.split(';');
		
		var ids = [];
		
		for (var index = 0; index < cookies.length; index++){

			if (cookies[index].search(identifier) != -1)
				ids.push((cookies[index].substr(cookies[index].indexOf('=') + 1)));
		}
		
		return ids;
	}


	/**
	 * Returns the route to most WCS endpoints
	 *
	 * @return {string} Path set with setContextRoot()
	 * 	 - defaults to '/webapp/wcs/stores/servlet/' when not set
	 **/
	function getContextRoot() {
		return ContextRoot;
	}

	/**
	 * Set the context root for where most WCS endpoints are located
	 *
	 * @param {string} path to WCS routes
	 **/
	function setContextRoot(path) {
		ContextRoot = path;
	}

	/**
	 * Returns the route to most WCS endpoints
	 *
	 * @return {string} Path set with setContextRoot()
	 * 	 - defaults to '/shop/' when not set
	 **/
	function getSEOContextRoot() { 
		return SEOContextRoot;
	}

	/**
	 * Set the SEO-friendly context root for where most WCS endpoints are located
	 *
	 * @param {string} path to WCS routes
	 **/
	function setSEOContextRoot(path) {
		SEOContextRoot = path;
	}

	function getURLWithContextRoot(view) {
		if (view) {
			var viewCompare = view.toLowerCase();

			return (viewCompare.lastIndexOf("http://", 0) !== 0 && viewCompare.lastIndexOf("https://", 0) !== 0 && viewCompare.lastIndexOf("/", 0) !== 0 ? getContextRoot() : "") + view;
		}

		return view;
	}

	function getParameterByName(name, url) {
	    if (!url) {
	      url = window.location.href;
	    }
	    name = name.replace(/[\[\]]/g, "\\$&");
	    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
	        results = regex.exec(url);
	    if (!results) return null;
	    if (!results[2]) return '';
	    return decodeURIComponent(results[2].replace(/\+/g, " "));
	}

	function getURLWithSEOContextRoot(view) {
		if (view) {
			var viewCompare = view.toLowerCase();

			return (viewCompare.lastIndexOf("http://", 0) !== 0 && viewCompare.lastIndexOf("https://", 0) !== 0 && viewCompare.lastIndexOf("/", 0) !== 0 ? getSEOContextRoot() : "") + view;
		}

		return view;
	}
	function getStoreId() { return $("meta[name='storeId']").attr("content"); }
	function getLangId() { return $("meta[name='langId']").attr("content"); }
	function getCatalogId() { return $("meta[name='catalogId']").attr("content"); }
	function getUserType() { return getWCCookie("USER_TYPE", "G"); }
	function isEcomEnabled() { return $("meta[name='ecomEnabled']").attr("content"); }
	function getShoppingCart() { return JSON.parse(getWCCookie("SHOPPINGCART", '{"quantity":"0"}')); }
	function getWishList() { return JSON.parse(getWCCookie("WISHLIST", '{"quantity":"0"}')); }
	function getFavoritesList() { return JSON.parse(getWCCookie("FAVORITESLIST", '{"product":[],"sku":[]}')); }
	function getLoyaltyOptIn() { return getWCCookie("LOYALTY_OPT_IN", "0"); }
	function getLoyaltyPoints() { return getWCCookie("LOYALTY_PEAK_POINTS", null); }
	function getLoyaltyPointsYear() { return getWCCookie("LOYALTY_POINTS_YEAR", null); }
	function getLoyaltyRedemptionPoints() { return getWCCookie("LOYALTY_REDEMPTION_POINTS", null); }
	function getLoyaltyProgramStatusCookie() { return getWCCookie("vf_loyalty_status_", null); }
	function getCategoryId() { 
		var cId="";
		try {
			cId = $("meta[name='categoryId']").attr("content");
		} catch(e){}
		
		return cId; 
	}
	function getLocale() { return $("meta[name='locale']").attr("content"); }
	function getUserId() {
		var memberId;
		var userId;
		var storeId;
		var activityPointerCookieList = [];
		if ("R" === getUserType()) {
			userId = getCookies("WCS_USERID")[0];
			activityPointerCookieList = getCookies("WC_ACTIVEPOINTER");
			for (var m = 0; m < activityPointerCookieList.length; m++) {
				storeId = decodeURIComponent(activityPointerCookieList[m]).split(",")[1];
				memberId = undefined;
				if (storeId === getStoreId() && "-1002" !== userId) {
					memberId = userId;
					break;
				}
			}
		}
		return memberId;
	}
	
	return {
		getCookie: getCookie,
		getWCCookie: getWCCookie,
		setCookie: setCookie,
		setWCCookie: setWCCookie,
		getWCCookieName: getWCCookieName,
		getParameterByName: getParameterByName,
		removeCookie: removeCookie,
		removeCookies: removeCookies,
		removeWCCookie: removeWCCookie,
		getCookies:getCookies,
		getContextRoot: getContextRoot,
		setContextRoot: setContextRoot,
		getSEOContextRoot: getSEOContextRoot,
		setSEOContextRoot: setSEOContextRoot,
		getURLWithContextRoot: getURLWithContextRoot,
		getURLWithSEOContextRoot: getURLWithSEOContextRoot,
		getCategoryId: getCategoryId,
		getStoreId: getStoreId,
		getLangId: getLangId,
		getCatalogId: getCatalogId,
		getUserType: getUserType,
		getUserId: getUserId,
		isEcomEnabled: isEcomEnabled,
		getShoppingCart: getShoppingCart,
		getWishList: getWishList,
		getFavoritesList: getFavoritesList,
		getLoyaltyOptIn: getLoyaltyOptIn,
		getLoyaltyPoints: getLoyaltyPoints,
		getLoyaltyPointsYear: getLoyaltyPointsYear,
		getLoyaltyRedemptionPoints: getLoyaltyRedemptionPoints,
		getLoyaltyProgramStatusCookie: getLoyaltyProgramStatusCookie,
		getLocale: getLocale
	};
});